import { AccountPermissionsService } from './../../../services/account-permissions.service';
import {Component, HostListener} from '@angular/core';
import {ParcelsService} from '../../../services/parcels.service';
import {UrlService} from '../../../services/url.service';
import { AuthenticationService } from '../../../services/authentication.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'parcels-list',
    templateUrl: './parcels-list.component.html',
    styleUrls: ['./parcels-list.component.scss']
})
export class ParcelsListComponent {
    constructor(
        public userServive: AccountPermissionsService,
        public urlService: UrlService,
        public parcelsService: ParcelsService,
        public authenticationService: AuthenticationService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.parcelsService.data.allParcels.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    showHint(e) {
        const $td = $(e.target).closest('.parcels-hint-td');
        if ($td.hasClass('active'))
            $td.removeClass('active');
        else {
            $('.parcels-hint-td').removeClass('active');
            $td.addClass('active');
        }
    }

    receiverHasEmailOrPhone(item) {
        return item.residentEmail || item.residentMobilePhone;
    }

    toggleCheck(selectedItem): void {
        const checked = selectedItem.showDetailedView;
        this.parcelsService.data.allParcels.data.forEach(item => item.showDetailedView = false);
        if (checked && this.parcelsService.selectedItemData) {
            this.parcelsService.selectedItemData = null;
            this.parcelsService.toggleDetailedView(null, false);
            selectedItem.showDetailedView = false;
        } else {
            this.parcelsService.selectedItemData = selectedItem;
            selectedItem.showDetailedView = true;
            this.parcelsService.toggleDetailedView(selectedItem, true);
        }
    }

    onlyReceivedFilterChecked() {
        return this.urlService.queryParams.status == 'received';
    }

    @HostListener('document:click', ['$event.target'])
    hideHint(targetElement: HTMLElement): void {
        if (!$(targetElement).closest('.parcels-hint-td').length) {
            $('.parcels-hint-td').removeClass('active');
        }
    }

}



// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcels-list/parcels-list.component.ts